import * as React from "react";
const TryInStoreContext = React.createContext(null);
TryInStoreContext.displayName = "TryInStoreContext";
const useTryInStoreContext = () => {
  const context = React.useContext(TryInStoreContext);
  if (!context) {
    throw new Error(
      "No Try In Store Context available. You might still need to wrap the application with the TryInStoreProvider component."
    );
  }
  return context;
};
export {
  TryInStoreContext,
  useTryInStoreContext
};
//# sourceMappingURL=context.js.map
